// // import React, { useState, useEffect } from 'react';
// // import { useSelector } from 'react-redux';
// // import configService from '../services/config';
// // import './Report.css';

// // // ---------- Helpers ----------
// // const fmt = (iso) =>
// //   !iso ? '—' : new Date(iso).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });

// // const getUTCDateString = (date) => {
// //   return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
// //     .toISOString()
// //     .split('T')[0];
// // };

// // const getLast7DaysUTC = () => {
// //   const dates = [];
// //   const today = new Date();
// //   for (let i = 6; i >= 0; i--) {
// //     const d = new Date(today);
// //     d.setDate(d.getDate() - i);
// //     dates.push(getUTCDateString(d));
// //   }
// //   return dates;
// // };

// // const formatDuration = (hours) => {
// //   if (hours === null || hours === undefined) return '—';
// //   return `${hours.toFixed(1)} HOURS`;
// // };

// // const fmtDate = (iso) =>
// //   !iso ? '—' : new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

// // // ---------- Component ----------
// // export default function Report() {
// //   const { company_id, userId } = useSelector((state) => state.globalVariables);
// //   const [weeklyData, setWeeklyData] = useState([]);
// //   const [weeklyLoading, setWeeklyLoading] = useState(true);

// //   const fetchWeeklySummary = async () => {
// //     setWeeklyLoading(true);
// //     try {
// //       const today = new Date();
// //       const endDate = getUTCDateString(today);
// //       const startDateObj = new Date(today);
// //       startDateObj.setDate(today.getDate() - 6);
// //       const startDate = getUTCDateString(startDateObj);

// //       // Fetch attendance + regularization data in parallel
// //       const [attendanceRes, regRes] = await Promise.all([
// //         configService.getAttendanceByDateRange({
// //           company_id,
// //           employee_id: userId,
// //           start_date: startDate,
// //           end_date: endDate,
// //         }),
// //         configService.getRegularizationList({
// //           company_id,
// //           employee_id: userId,
// //         }),
// //       ]);

// //       let records = [];
// //       if (attendanceRes?.status || attendanceRes?.data?.status) {
// //         records = attendanceRes.data?.data || attendanceRes.data || [];
// //       }
// //       if (!Array.isArray(records)) records = [];

// //       let regularizations = [];
// //       if (regRes?.status || regRes?.data?.status) {
// //         regularizations = regRes.data?.data || regRes.data || [];
// //       }
// //       if (!Array.isArray(regularizations)) regularizations = [];

// //       // Map attendance records by UTC date key
// //       const recordMap = {};
// //       records.forEach((rec) => {
// //         if (rec?.date) {
// //           const dateObj = new Date(rec.date);
// //           const dateKey = getUTCDateString(dateObj);
// //           recordMap[dateKey] = rec;
// //         }
// //       });

// //       // Map regularization records by UTC date key (entry_date)
// //       const regMap = {};
// //       regularizations.forEach((reg) => {
// //         if (reg?.entry_date) {
// //           const dateObj = new Date(reg.entry_date);
// //           const dateKey = getUTCDateString(dateObj);
// //           regMap[dateKey] = reg;
// //         }
// //       });

// //       // Generate the last 7 days and compute summary
// //       const days = getLast7DaysUTC();
// //       const summary = days.map((dateKey) => {
// //         const record = recordMap[dateKey] || null;
// //         const regularization = regMap[dateKey] || null;
// //         const [year, month, day] = dateKey.split('-').map(Number);
// //         const dateObj = new Date(Date.UTC(year, month - 1, day));
// //         const weekday = dateObj.toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' });

// //         let punchIn = '—';
// //         let punchOut = '—';
// //         let durationHours = null;
// //         const workHour = 8;
// //         let shortHour = 0;
// //         let extraHour = 0;

// //         if (record) {
// //           punchIn = fmt(record.punch_in);
// //           punchOut = fmt(record.punch_out);
// //           if (record.punch_in && record.punch_out) {
// //             const inTime = new Date(record.punch_in).getTime();
// //             const outTime = new Date(record.punch_out).getTime();
// //             if (outTime > inTime) {
// //               durationHours = (outTime - inTime) / (1000 * 60 * 60);
// //               durationHours = Math.round(durationHours * 10) / 10;
// //               if (durationHours > 8) {
// //                 extraHour = Math.round((durationHours - 8) * 10) / 10;
// //                 shortHour = 0;
// //               } else if (durationHours < 8) {
// //                 shortHour = Math.round((8 - durationHours) * 10) / 10;
// //                 extraHour = 0;
// //               } else {
// //                 shortHour = 0;
// //                 extraHour = 0;
// //               }
// //             }
// //           }
// //         }

// //         // --- Safe regularization status resolution ---
// //         let regStatus = '—';
// //         if (regularization) {
// //           if (typeof regularization.status === 'string' && regularization.status.trim() !== '') {
// //             regStatus = regularization.status;
// //           } else {
// //             regStatus = 'Pending';
// //           }
// //         }

// //         return {
// //           date: fmtDate(dateKey),
// //           week: weekday,
// //           punchIn,
// //           punchOut,
// //           duration: durationHours !== null ? formatDuration(durationHours) : '—',
// //           workHour: formatDuration(workHour),
// //           shortHour: shortHour > 0 ? formatDuration(shortHour) : '0 HOURS',
// //           extraHour: extraHour > 0 ? formatDuration(extraHour) : '0 HOURS',
// //           regularization: regStatus,
// //         };
// //       });

// //       setWeeklyData(summary);
// //     } catch (error) {
// //       console.error('❌ Fetch Weekly Summary Error:', error);
// //       setWeeklyData([]);
// //     } finally {
// //       setWeeklyLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (userId) {
// //       fetchWeeklySummary();
// //     }
// //   }, [userId, company_id]);

// //   return (
// //     <div className="weekly-page-wrapper">
// //       <div className="weekly-modal-card weekly-page-card">
// //         <div className="weekly-modal-body">
// //           <h3 className="weekly-modal-title">Weekly Attendance Summary</h3>

// //           {weeklyLoading ? (
// //             <div className="weekly-loading-wrap">
// //               <div className="weekly-spinner" />
// //             </div>
// //           ) : weeklyData.length === 0 ? (
// //             <div className="weekly-empty-text">No attendance data available.</div>
// //           ) : (
// //             <div className="weekly-table-container">
// //               <div className="weekly-table-responsive">
// //                 <table className="weekly-table">
// //                   <thead>
// //                     <tr>
// //                       <th>Date</th>
// //                       <th>Week</th>
// //                       <th>Punch In</th>
// //                       <th>Punch Out</th>
// //                       <th>Duration</th>
// //                       <th>Work Hour</th>
// //                       <th>Short Hour</th>
// //                       <th>Extra Hour</th>
// //                       <th>Regularization</th>
// //                     </tr>
// //                   </thead>
// //                   <tbody>
// //                     {weeklyData.map((row, index) => {
// //                       const regValue =
// //                         row.regularization && typeof row.regularization === 'string'
// //                           ? row.regularization
// //                           : '—';
// //                       const isRegSet = regValue !== '—';

// //                       return (
// //                         <tr key={index}>
// //                           <td>{row.date}</td>
// //                           <td className="weekly-day-cell">{row.week}</td>
// //                           <td className={row.punchIn === 'weekly off' ? 'weekly-off' : ''}>{row.punchIn}</td>
// //                           <td className={row.punchOut === 'weekly off' ? 'weekly-off' : ''}>{row.punchOut}</td>
// //                           <td>{row.duration}</td>
// //                           <td>{row.workHour}</td>
// //                           <td className={row.shortHour !== '0 HOURS' ? 'weekly-short-hour' : ''}>{row.shortHour}</td>
// //                           <td>{row.extraHour}</td>
// //                           <td>
// //                             {isRegSet ? (
// //                               <span className={`weekly-reg-badge weekly-reg-${regValue.toLowerCase()}`}>
// //                                 {regValue}
// //                               </span>
// //                             ) : (
// //                               <span className="weekly-off">—</span>
// //                             )}
// //                           </td>
// //                         </tr>
// //                       );
// //                     })}
// //                   </tbody>
// //                 </table>
// //               </div>
// //             </div>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }



// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import toast from 'react-hot-toast';
// import configService from '../services/config';
// import './Report.css';
// import {
//   Modal,
//   Card,
//   CardContent,
//   Typography,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   TextField,
//   InputAdornment,
//   Box,
//   Button,
//   Dialog,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   ToggleButton,
//   ToggleButtonGroup
// } from '@mui/material';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import KeyboardIcon from '@mui/icons-material/Keyboard';

// // ---------- Helpers ----------
// const fmt = (iso) =>
//   !iso ? '—' : new Date(iso).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });

// const getUTCDateString = (date) => {
//   return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
//     .toISOString()
//     .split('T')[0];
// };

// const getLast7DaysUTC = () => {
//   const dates = [];
//   const today = new Date();
//   for (let i = 6; i >= 0; i--) {
//     const d = new Date(today);
//     d.setDate(d.getDate() - i);
//     dates.push(getUTCDateString(d));
//   }
//   return dates;
// };

// const formatDuration = (hours) => {
//   if (hours === null || hours === undefined) return '—';
//   return `${hours.toFixed(1)} HOURS`;
// };

// const fmtDate = (iso) =>
//   !iso ? '—' : new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

// // 12-hour to 24-hour converter (same logic as Apply Regularization form)
// const convertTo24Hour = (timeStr) => {
//   if (!timeStr || timeStr === '—') return '00:00:00';
//   const [time, modifier] = timeStr.split(' ');
//   let [hours, minutes] = time.split(':');

//   if (hours === '12') {
//     hours = '00';
//   }
//   if (modifier === 'PM') {
//     hours = parseInt(hours, 10) + 12;
//   }

//   return `${String(hours).padStart(2, '0')}:${minutes}:00`;
// };

// // ---------- Component ----------
// export default function Report() {
//   const { company_id, userId } = useSelector((state) => state.globalVariables);
//   const [weeklyData, setWeeklyData] = useState([]);
//   const [weeklyLoading, setWeeklyLoading] = useState(true);

//   // --- Apply Regularization Modal States (merged from AttendanceRegularizationList) ---
//   const [openModal, setOpenModal] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [category, setCategory] = useState('');
//   const [timeType, setTimeType] = useState('');
//   const [selectedDate, setSelectedDate] = useState('');
//   const [beginningTime, setBeginningTime] = useState('12:00 AM');
//   const [endTime, setEndTime] = useState('12:00 AM');

//   // --- Clock Picker States ---
//   const [openPicker, setOpenPicker] = useState(false);
//   const [activeField, setActiveField] = useState('beginning');
//   const [pickerView, setPickerView] = useState('hours');
//   const [selectedHour, setSelectedHour] = useState('12');
//   const [selectedMinute, setSelectedMinute] = useState('00');
//   const [ampm, setAmpm] = useState('AM');

//   const fetchWeeklySummary = async () => {
//     setWeeklyLoading(true);
//     try {
//       const today = new Date();
//       const endDate = getUTCDateString(today);
//       const startDateObj = new Date(today);
//       startDateObj.setDate(today.getDate() - 6);
//       const startDate = getUTCDateString(startDateObj);

//       // Fetch attendance + regularization data in parallel
//       const [attendanceRes, regRes] = await Promise.all([
//         configService.getAttendanceByDateRange({
//           company_id,
//           employee_id: userId,
//           start_date: startDate,
//           end_date: endDate,
//         }),
//         configService.getRegularizationList({
//           company_id,
//           employee_id: userId,
//         }),
//       ]);

//       let records = [];
//       if (attendanceRes?.status || attendanceRes?.data?.status) {
//         records = attendanceRes.data?.data || attendanceRes.data || [];
//       }
//       if (!Array.isArray(records)) records = [];

//       let regularizations = [];
//       if (regRes?.status || regRes?.data?.status) {
//         regularizations = regRes.data?.data || regRes.data || [];
//       }
//       if (!Array.isArray(regularizations)) regularizations = [];

//       // Map attendance records by UTC date key
//       const recordMap = {};
//       records.forEach((rec) => {
//         if (rec?.date) {
//           const dateObj = new Date(rec.date);
//           const dateKey = getUTCDateString(dateObj);
//           recordMap[dateKey] = rec;
//         }
//       });

//       // Map regularization records by UTC date key (entry_date)
//       const regMap = {};
//       regularizations.forEach((reg) => {
//         if (reg?.entry_date) {
//           const dateObj = new Date(reg.entry_date);
//           const dateKey = getUTCDateString(dateObj);
//           regMap[dateKey] = reg;
//         }
//       });

//       // Generate the last 7 days and compute summary
//       const days = getLast7DaysUTC();
//       const summary = days.map((dateKey) => {
//         const record = recordMap[dateKey] || null;
//         const regularization = regMap[dateKey] || null;
//         const [year, month, day] = dateKey.split('-').map(Number);
//         const dateObj = new Date(Date.UTC(year, month - 1, day));
//         const weekday = dateObj.toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' });

//         let punchIn = '—';
//         let punchOut = '—';
//         let durationHours = null;
//         const workHour = 8;
//         let shortHour = 0;
//         let extraHour = 0;

//         if (record) {
//           punchIn = fmt(record.punch_in);
//           punchOut = fmt(record.punch_out);
//           if (record.punch_in && record.punch_out) {
//             const inTime = new Date(record.punch_in).getTime();
//             const outTime = new Date(record.punch_out).getTime();
//             if (outTime > inTime) {
//               durationHours = (outTime - inTime) / (1000 * 60 * 60);
//               durationHours = Math.round(durationHours * 10) / 10;
//               if (durationHours > 8) {
//                 extraHour = Math.round((durationHours - 8) * 10) / 10;
//                 shortHour = 0;
//               } else if (durationHours < 8) {
//                 shortHour = Math.round((8 - durationHours) * 10) / 10;
//                 extraHour = 0;
//               } else {
//                 shortHour = 0;
//                 extraHour = 0;
//               }
//             }
//           }
//         }

//         // --- Safe regularization status resolution ---
//         let regStatus = '—';
//         if (regularization) {
//           if (typeof regularization.status === 'string' && regularization.status.trim() !== '') {
//             regStatus = regularization.status;
//           } else {
//             regStatus = 'Pending';
//           }
//         }

//         return {
//           rawDate: dateKey, // ISO date, needed to prefill the regularization form
//           date: fmtDate(dateKey),
//           week: weekday,
//           punchIn,
//           punchOut,
//           duration: durationHours !== null ? formatDuration(durationHours) : '—',
//           workHour: formatDuration(workHour),
//           shortHour: shortHour > 0 ? formatDuration(shortHour) : '0 HOURS',
//           extraHour: extraHour > 0 ? formatDuration(extraHour) : '0 HOURS',
//           isShort: shortHour > 0, // true only when attendance is short -> regularization allowed
//           regularization: regStatus,
//         };
//       });

//       setWeeklyData(summary);
//     } catch (error) {
//       console.error('❌ Fetch Weekly Summary Error:', error);
//       setWeeklyData([]);
//     } finally {
//       setWeeklyLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (userId) {
//       fetchWeeklySummary();
//     }
//   }, [userId, company_id]);

//   // --- Open the Apply Regularization modal for a specific (short) day ---
//   const handleOpenRegularizeModal = (row) => {
//     setCategory('');
//     setTimeType('');
//     setBeginningTime('12:00 AM');
//     setEndTime('12:00 AM');
//     setSelectedDate(row.rawDate);
//     setOpenModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setCategory('');
//     setTimeType('');
//     setBeginningTime('12:00 AM');
//     setEndTime('12:00 AM');
//     setSelectedDate('');
//   };

//   // --- Submission Logic (same as AttendanceRegularizationList) ---
//   const handleSave = async () => {
//     if (!category || !timeType || !selectedDate) {
//       toast.error('Please fill all the required fields (Category, Time Type, and Date).');
//       return;
//     }

//     const formattedBeginning = convertTo24Hour(beginningTime);
//     const formattedEnd = convertTo24Hour(endTime);

//     const formData = {
//       company_id: company_id,
//       employee_id: userId,
//       customer_id: userId,
//       category: category,
//       time_type: timeType,
//       entry_date: selectedDate,
//       beginning: formattedBeginning,
//       end_time: formattedEnd,
//       remarks: timeType,
//     };

//     try {
//       setSaving(true);
//       const res = await configService.attendanceregularization(formData);

//       if (res?.status === true || res?.data?.status === true || res?.status === 201) {
//         toast.success('Attendance Regularization saved successfully!');
//         handleCloseModal();
//         await fetchWeeklySummary(); // Refresh table data so the badge/button updates
//       } else {
//         toast.error(res?.data?.message || res?.message || 'Failed to save.');
//       }
//     } catch (error) {
//       console.error('Error saving attendance regularization:', error);
//       toast.error(`Error: ${error?.response?.data?.message || error?.message || 'Server Error'}`);
//     } finally {
//       setSaving(false);
//     }
//   };

//   // --- Clock Picker Logic ---
//   const handleOpenPicker = (field, currentTime) => {
//     setActiveField(field);
//     try {
//       const [time, period] = currentTime.split(' ');
//       const [hr, min] = time.split(':');
//       setSelectedHour(hr || '12');
//       setSelectedMinute(min || '00');
//       setAmpm(period || 'AM');
//     } catch (e) {
//       setSelectedHour('12');
//       setSelectedMinute('00');
//       setAmpm('AM');
//     }
//     setPickerView('hours');
//     setOpenPicker(true);
//   };

//   const handleClockSave = () => {
//     const formattedTime = `${selectedHour}:${selectedMinute} ${ampm}`;
//     if (activeField === 'beginning') {
//       setBeginningTime(formattedTime);
//     } else {
//       setEndTime(formattedTime);
//     }
//     setOpenPicker(false);
//   };

//   const hoursData = [
//     { n: '12', deg: 0 }, { n: '01', deg: 30 }, { n: '02', deg: 60 },
//     { n: '03', deg: 90 }, { n: '04', deg: 120 }, { n: '05', deg: 150 },
//     { n: '06', deg: 180 }, { n: '07', deg: 210 }, { n: '08', deg: 240 },
//     { n: '09', deg: 270 }, { n: '10', deg: 300 }, { n: '11', deg: 330 }
//   ];

//   const minutesData = [
//     { n: '00', deg: 0 }, { n: '05', deg: 30 }, { n: '10', deg: 60 },
//     { n: '15', deg: 90 }, { n: '20', deg: 120 }, { n: '25', deg: 150 },
//     { n: '30', deg: 180 }, { n: '35', deg: 210 }, { n: '40', deg: 240 },
//     { n: '45', deg: 270 }, { n: '50', deg: 300 }, { n: '55', deg: 330 }
//   ];

//   const currentData = pickerView === 'hours' ? hoursData : minutesData;
//   const currentSelection = pickerView === 'hours' ? selectedHour : selectedMinute;
//   const currentRotation = currentData.find(d => d.n === currentSelection)?.deg || 0;

//   return (
//     <div className="weekly-page-wrapper">
//       <div className="weekly-modal-card weekly-page-card">
//         <div className="weekly-modal-body">
//           <h3 className="weekly-modal-title">Weekly Attendance Summary</h3>

//           {weeklyLoading ? (
//             <div className="weekly-loading-wrap">
//               <div className="weekly-spinner" />
//             </div>
//           ) : weeklyData.length === 0 ? (
//             <div className="weekly-empty-text">No attendance data available.</div>
//           ) : (
//             <div className="weekly-table-container">
//               <div className="weekly-table-responsive">
//                 <table className="weekly-table">
//                   <thead>
//                     <tr>
//                       <th>Date</th>
//                       <th>Week</th>
//                       <th>Punch In</th>
//                       <th>Punch Out</th>
//                       <th>Duration</th>
//                       <th>Work Hour</th>
//                       <th>Short Hour</th>
//                       <th>Extra Hour</th>
//                       <th>Regularization</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {weeklyData.map((row, index) => {
//                       const regValue =
//                         row.regularization && typeof row.regularization === 'string'
//                           ? row.regularization
//                           : '—';
//                       const isRegSet = regValue !== '—';

//                       return (
//                         <tr key={index}>
//                           <td>{row.date}</td>
//                           <td className="weekly-day-cell">{row.week}</td>
//                           <td className={row.punchIn === 'weekly off' ? 'weekly-off' : ''}>{row.punchIn}</td>
//                           <td className={row.punchOut === 'weekly off' ? 'weekly-off' : ''}>{row.punchOut}</td>
//                           <td>{row.duration}</td>
//                           <td>{row.workHour}</td>
//                           <td className={row.shortHour !== '0 HOURS' ? 'weekly-short-hour' : ''}>{row.shortHour}</td>
//                           <td>{row.extraHour}</td>
//                           <td>
//                             {isRegSet ? (
//                               // Already requested / approved / rejected -> just show the status badge
//                               <span className={`weekly-reg-badge weekly-reg-${regValue.toLowerCase()}`}>
//                                 {regValue}
//                               </span>
//                             ) : row.isShort ? (
//                               // Attendance is short and not yet regularized -> allow applying
//                               <Button
//                                 size="small"
//                                 variant="outlined"
//                                 onClick={() => handleOpenRegularizeModal(row)}
//                                 sx={{
//                                   textTransform: 'none',
//                                   fontSize: 12,
//                                   fontWeight: 600,
//                                   borderColor: '#6c5ce7',
//                                   color: '#6c5ce7',
//                                   borderRadius: 2,
//                                   px: 1.5,
//                                   py: 0.3,
//                                   '&:hover': { borderColor: '#5b4bc4', bgcolor: 'rgba(108, 92, 231, 0.08)' }
//                                 }}
//                               >
//                                 Regularize
//                               </Button>
//                             ) : (
//                               // Full attendance, nothing to regularize
//                               <span className="weekly-off">—</span>
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* ── Apply Regularization Modal (merged from AttendanceRegularizationList) ── */}
//       <Modal
//         open={openModal}
//         onClose={handleCloseModal}
//         sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, zIndex: 1000 }}
//       >
//         <Card sx={{
//           width: '100%',
//           maxWidth: 500,
//           bgcolor: '#ffffff',
//           border: '1px solid #e2e8f0',
//           borderRadius: 4,
//           color: '#1e293b',
//           boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
//         }}>
//           <CardContent sx={{ p: 4 }}>
//             <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, color: '#1e293b' }}>
//               New Regularization Request
//             </Typography>

//             <Grid container spacing={3}>
//               {/* 1. Category */}
//               <Grid item xs={12}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel id="cat-label" sx={{ color: '#64748b', '&.Mui-focused': { color: '#6c5ce7' } }}>Category</InputLabel>
//                   <Select
//                     labelId="cat-label"
//                     value={category}
//                     label="Category"
//                     onChange={(e) => setCategory(e.target.value)}
//                     sx={{
//                       color: '#1e293b',
//                       '.MuiOutlinedInput-notchedOutline': { borderColor: '#cbd5e1' },
//                       '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#94a3b8' },
//                       '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#6c5ce7' },
//                       '.MuiSvgIcon-root': { color: '#64748b' }
//                     }}
//                     MenuProps={{ PaperProps: { sx: { bgcolor: '#ffffff', color: '#1e293b', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)' } } }}
//                   >
//                     <MenuItem value="Working Times">Working Times</MenuItem>
//                     <MenuItem value="Break">Break</MenuItem>
//                     <MenuItem value="Overtime">Overtime</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* 2. Time Type */}
//               <Grid item xs={12}>
//                 <FormControl fullWidth size="small">
//                   <InputLabel id="type-label" sx={{ color: '#64748b', '&.Mui-focused': { color: '#6c5ce7' } }}>Time Type</InputLabel>
//                   <Select
//                     labelId="type-label"
//                     value={timeType}
//                     label="Time Type"
//                     onChange={(e) => setTimeType(e.target.value)}
//                     sx={{
//                       color: '#1e293b',
//                       '.MuiOutlinedInput-notchedOutline': { borderColor: '#cbd5e1' },
//                       '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#94a3b8' },
//                       '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#6c5ce7' },
//                       '.MuiSvgIcon-root': { color: '#64748b' }
//                     }}
//                     MenuProps={{ PaperProps: { sx: { bgcolor: '#ffffff', color: '#1e293b', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)' } } }}
//                   >
//                     <MenuItem value="Attendance Regularization">Attendance Regularization</MenuItem>
//                     <MenuItem value="On Duty">On Duty</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               {/* 3. Date (locked to the short day the user clicked "Regularize" on) */}
//               <Grid item xs={12}>
//                 <TextField
//                   label="Date"
//                   type="date"
//                   value={selectedDate}
//                   fullWidth
//                   size="small"
//                   InputProps={{
//                     readOnly: true,
//                     endAdornment: (
//                       <InputAdornment position="end">
//                         <CalendarTodayIcon sx={{ color: '#6c5ce7', fontSize: '1.2rem' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   InputLabelProps={{ shrink: true }}
//                   sx={{
//                     '& .MuiInputLabel-root': { color: '#64748b' },
//                     '& .MuiInputLabel-root.Mui-focused': { color: '#6c5ce7' },
//                     '& .MuiOutlinedInput-root': {
//                       color: '#1e293b',
//                       bgcolor: '#f8fafc',
//                       '& fieldset': { borderColor: '#cbd5e1' },
//                       '&:hover fieldset': { borderColor: '#94a3b8' },
//                       '&.Mui-focused fieldset': { borderColor: '#6c5ce7' },
//                     }
//                   }}
//                 />
//               </Grid>

//               {/* 4. Beginning Time */}
//               <Grid item xs={12}>
//                 <TextField
//                   label="Beginning"
//                   value={beginningTime}
//                   onClick={() => handleOpenPicker('beginning', beginningTime)}
//                   fullWidth
//                   size="small"
//                   InputProps={{
//                     readOnly: true,
//                     endAdornment: (
//                       <InputAdornment position="end">
//                         <AccessTimeIcon sx={{ color: '#6c5ce7', cursor: 'pointer' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{
//                     cursor: 'pointer',
//                     '& .MuiInputLabel-root': { color: '#64748b' },
//                     '& .MuiInputLabel-root.Mui-focused': { color: '#6c5ce7' },
//                     '& .MuiOutlinedInput-root': {
//                       color: '#1e293b',
//                       cursor: 'pointer',
//                       '& fieldset': { borderColor: '#cbd5e1' },
//                       '&:hover fieldset': { borderColor: '#94a3b8' },
//                       '&.Mui-focused fieldset': { borderColor: '#6c5ce7' },
//                     },
//                     '& input': { cursor: 'pointer' }
//                   }}
//                 />
//               </Grid>

//               {/* 5. End Time */}
//               <Grid item xs={12}>
//                 <TextField
//                   label="End"
//                   value={endTime}
//                   onClick={() => handleOpenPicker('end', endTime)}
//                   fullWidth
//                   size="small"
//                   InputProps={{
//                     readOnly: true,
//                     endAdornment: (
//                       <InputAdornment position="end">
//                         <AccessTimeIcon sx={{ color: '#6c5ce7', cursor: 'pointer' }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{
//                     cursor: 'pointer',
//                     '& .MuiInputLabel-root': { color: '#64748b' },
//                     '& .MuiInputLabel-root.Mui-focused': { color: '#6c5ce7' },
//                     '& .MuiOutlinedInput-root': {
//                       color: '#1e293b',
//                       cursor: 'pointer',
//                       '& fieldset': { borderColor: '#cbd5e1' },
//                       '&:hover fieldset': { borderColor: '#94a3b8' },
//                       '&.Mui-focused fieldset': { borderColor: '#6c5ce7' },
//                     },
//                     '& input': { cursor: 'pointer' }
//                   }}
//                 />
//               </Grid>

//               {/* 6. Created By */}
//               <Grid item xs={12}>
//                 <TextField
//                   label="Created By"
//                   value={userId || 'User'}
//                   fullWidth
//                   size="small"
//                   InputProps={{
//                     readOnly: true,
//                     startAdornment: (
//                       <InputAdornment position="start">
//                         <AccountCircleIcon sx={{ color: '#94a3b8', mr: 0.5 }} />
//                       </InputAdornment>
//                     ),
//                   }}
//                   sx={{
//                     '& .MuiInputLabel-root': { color: '#64748b' },
//                     '& .MuiOutlinedInput-root': {
//                       color: '#64748b',
//                       bgcolor: '#f8fafc',
//                       '& fieldset': { borderColor: '#cbd5e1' },
//                     }
//                   }}
//                 />
//               </Grid>
//             </Grid>

//             {/* Modal Actions */}
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
//               <Button onClick={handleCloseModal} sx={{ color: '#64748b', '&:hover': { color: '#1e293b', bgcolor: '#f1f5f9' }, textTransform: 'none' }}>
//                 Cancel
//               </Button>
//               <Button
//                 variant="contained"
//                 onClick={handleSave}
//                 disabled={saving}
//                 sx={{ bgcolor: '#6c5ce7', color: '#fff', px: 3, textTransform: 'none', '&:hover': { bgcolor: '#5b4bc4' } }}
//               >
//                 {saving ? 'Saving...' : 'Save'}
//               </Button>
//             </Box>
//           </CardContent>
//         </Card>
//       </Modal>

//       {/* ── CUSTOM RADIAL CLOCK DIALOG PICKER ── */}
//       <Dialog
//         open={openPicker}
//         onClose={() => setOpenPicker(false)}
//         PaperProps={{
//           sx: {
//             borderRadius: 4,
//             p: 3,
//             maxWidth: '340px',
//             width: '100%',
//             bgcolor: '#ffffff',
//             border: '1px solid #e2e8f0',
//             color: '#1e293b',
//             boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)'
//           }
//         }}
//         sx={{ zIndex: 1100 }}
//       >
//         <DialogContent sx={{ p: 0, overflow: 'visible' }}>
//           <Typography variant="body2" sx={{ color: '#64748b', mb: 2, fontWeight: 500 }}>
//             Select time
//           </Typography>

//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 3 }}>
//             <Box
//               onClick={() => setPickerView('hours')}
//               sx={{
//                 bgcolor: pickerView === 'hours' ? 'rgba(108, 92, 231, 0.1)' : '#f8fafc',
//                 px: 2.5, py: 1.5, borderRadius: 2, cursor: 'pointer',
//                 border: pickerView === 'hours' ? '1px solid #6c5ce7' : '1px solid #cbd5e1'
//               }}
//             >
//               <Typography variant="h3" sx={{ color: pickerView === 'hours' ? '#6c5ce7' : '#1e293b', fontWeight: 500 }}>
//                 {selectedHour}
//               </Typography>
//             </Box>

//             <Typography variant="h4" sx={{ color: '#64748b' }}>:</Typography>

//             <Box
//               onClick={() => setPickerView('minutes')}
//               sx={{
//                 bgcolor: pickerView === 'minutes' ? 'rgba(108, 92, 231, 0.1)' : '#f8fafc',
//                 px: 2.5, py: 1.5, borderRadius: 2, cursor: 'pointer',
//                 border: pickerView === 'minutes' ? '1px solid #6c5ce7' : '1px solid #cbd5e1'
//               }}
//             >
//               <Typography variant="h3" sx={{ color: pickerView === 'minutes' ? '#6c5ce7' : '#1e293b', fontWeight: 500 }}>
//                 {selectedMinute}
//               </Typography>
//             </Box>

//             <ToggleButtonGroup
//               orientation="vertical"
//               value={ampm}
//               exclusive
//               onChange={(e, val) => val && setAmpm(val)}
//               sx={{
//                 border: '1px solid #cbd5e1',
//                 borderRadius: 2,
//                 ml: 1,
//                 bgcolor: '#f8fafc',
//                 '& .MuiToggleButton-root': {
//                   px: 1.5,
//                   py: 0.8,
//                   fontSize: '0.85rem',
//                   border: 'none',
//                   color: '#64748b',
//                   '&.Mui-selected': { bgcolor: 'rgba(108, 92, 231, 0.1)', color: '#6c5ce7', fontWeight: 'bold' }
//                 }
//               }}
//             >
//               <ToggleButton value="AM">AM</ToggleButton>
//               <ToggleButton value="PM" sx={{ borderTop: '1px solid #cbd5e1 !important' }}>PM</ToggleButton>
//             </ToggleButtonGroup>
//           </Box>

//           <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
//             <Box
//               sx={{
//                 width: 220,
//                 height: 220,
//                 borderRadius: '50%',
//                 bgcolor: '#f8fafc',
//                 position: 'relative',
//                 border: '1px solid #cbd5e1'
//               }}
//             >
//               <Box sx={{ width: 6, height: 6, bgcolor: '#6c5ce7', borderRadius: '50%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 3 }} />
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   width: 2,
//                   height: 76,
//                   bgcolor: '#6c5ce7',
//                   bottom: '50%',
//                   left: '50%',
//                   transformOrigin: 'bottom center',
//                   transform: `translateX(-50%) rotate(${currentRotation}deg)`,
//                   zIndex: 1
//                 }}
//               />

//               {currentData.map((item) => {
//                 const radius = 80;
//                 const angleRad = (item.deg - 90) * (Math.PI / 180);
//                 const x = 110 + radius * Math.cos(angleRad);
//                 const y = 110 + radius * Math.sin(angleRad);
//                 const isSelected = currentSelection === item.n;

//                 return (
//                   <Box
//                     key={item.n}
//                     onClick={() => {
//                       if (pickerView === 'hours') {
//                         setSelectedHour(item.n);
//                         setPickerView('minutes');
//                       } else {
//                         setSelectedMinute(item.n);
//                       }
//                     }}
//                     sx={{
//                       position: 'absolute',
//                       left: x,
//                       top: y,
//                       transform: 'translate(-50%, -50%)',
//                       fontSize: '0.85rem',
//                       color: isSelected ? '#fff' : '#475569',
//                       cursor: 'pointer',
//                       zIndex: 2,
//                       width: 32,
//                       height: 32,
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       borderRadius: '50%',
//                       transition: '0.1s',
//                       ...(isSelected && { bgcolor: '#6c5ce7', fontWeight: 'bold' }),
//                       '&:hover': { bgcolor: isSelected ? '#6c5ce7' : '#e2e8f0' }
//                     }}
//                   >
//                     {parseInt(item.n)}
//                   </Box>
//                 );
//               })}
//             </Box>
//           </Box>
//         </DialogContent>

//         <DialogActions sx={{ justifyContent: 'space-between', px: 0, pb: 0, pt: 2 }}>
//           <IconButton size="small" sx={{ color: '#64748b' }}>
//             <KeyboardIcon />
//           </IconButton>
//           <Box>
//             <Button onClick={() => setOpenPicker(false)} sx={{ textTransform: 'none', fontWeight: 600, color: '#64748b', mr: 1 }}>
//               Cancel
//             </Button>
//             <Button onClick={handleClockSave} sx={{ textTransform: 'none', fontWeight: 700, color: '#6c5ce7' }}>
//               OK
//             </Button>
//           </Box>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// }

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import configService from '../services/config';
import './Report.css';
import {
  Modal, Card, CardContent, Typography, Grid, FormControl, InputLabel,
  Select, MenuItem, TextField, InputAdornment, Box, Button, Dialog,
  DialogContent, DialogActions, IconButton, ToggleButton, ToggleButtonGroup
} from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import KeyboardIcon from '@mui/icons-material/Keyboard';

// ---------- Helpers ----------
const fmt = (iso) =>
  !iso ? '—' : new Date(iso).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });

const getUTCDateString = (date) => {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
    .toISOString()
    .split('T')[0];
};

const getLast7DaysUTC = () => {
  const dates = [];
  const today = new Date();
  for (let i = 6; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(d.getDate() - i);
    dates.push(getUTCDateString(d));
  }
  return dates;
};

const formatDuration = (hours) => {
  if (hours === null || hours === undefined) return '—';
  return `${hours.toFixed(1)} HOURS`;
};

const fmtDate = (iso) =>
  !iso ? '—' : new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });

// 12-hour to 24-hour converter
const convertTo24Hour = (timeStr) => {
  if (!timeStr || timeStr === '—') return '00:00:00';
  const [time, modifier] = timeStr.split(' ');
  let [hours, minutes] = time.split(':');

  if (hours === '12') { hours = '00'; }
  if (modifier === 'PM') { hours = parseInt(hours, 10) + 12; }
  return `${String(hours).padStart(2, '0')}:${minutes}:00`;
};

// Dial data for clock picker
const hoursData = [
  { n: '12', deg: 0 }, { n: '01', deg: 30 }, { n: '02', deg: 60 },
  { n: '03', deg: 90 }, { n: '04', deg: 120 }, { n: '05', deg: 150 },
  { n: '06', deg: 180 }, { n: '07', deg: 210 }, { n: '08', deg: 240 },
  { n: '09', deg: 270 }, { n: '10', deg: 300 }, { n: '11', deg: 330 }
];

const minutesData = [
  { n: '00', deg: 0 }, { n: '05', deg: 30 }, { n: '10', deg: 60 },
  { n: '15', deg: 90 }, { n: '20', deg: 120 }, { n: '25', deg: 150 },
  { n: '30', deg: 180 }, { n: '35', deg: 210 }, { n: '40', deg: 240 },
  { n: '45', deg: 270 }, { n: '50', deg: 300 }, { n: '55', deg: 330 }
];

// ---------- Main Component ----------
export default function Report() {
  const { company_id, userId } = useSelector((state) => state.globalVariables);

  const [weeklyData, setWeeklyData] = useState([]);
  const [weeklyLoading, setWeeklyLoading] = useState(true);

  // Today's Date for disabling current date button
  const todayDateStr = getUTCDateString(new Date());

  // --- Modal States ---
  const [openModal, setOpenModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [category, setCategory] = useState('');
  const [timeType, setTimeType] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [beginningTime, setBeginningTime] = useState('12:00 AM');
  const [endTime, setEndTime] = useState('12:00 AM');

  // --- Clock Picker States ---
  const [openPicker, setOpenPicker] = useState(false);
  const [activeField, setActiveField] = useState('beginning');
  const [pickerView, setPickerView] = useState('hours');
  const [selectedHour, setSelectedHour] = useState('12');
  const [selectedMinute, setSelectedMinute] = useState('00');
  const [ampm, setAmpm] = useState('AM');

  // Fetch API Data
  const fetchWeeklySummary = async () => {
    setWeeklyLoading(true);
    try {
      const today = new Date();
      const endDate = getUTCDateString(today);
      const startDateObj = new Date(today);
      startDateObj.setDate(today.getDate() - 6);
      const startDate = getUTCDateString(startDateObj);

      const [attendanceRes, regRes] = await Promise.all([
        configService.getAttendanceByDateRange({ company_id, employee_id: userId, start_date: startDate, end_date: endDate }),
        configService.getRegularizationList({ company_id, employee_id: userId })
      ]);

      let records = [];
      if (attendanceRes?.status || attendanceRes?.data?.status) {
        records = attendanceRes.data?.data || attendanceRes.data || [];
      }
      if (!Array.isArray(records)) records = [];

      let regularizations = [];
      if (regRes?.status || regRes?.data?.status) {
        regularizations = regRes.data?.data || regRes.data || [];
      }
      if (!Array.isArray(regularizations)) regularizations = [];

      const recordMap = {};
      records.forEach((rec) => {
        if (rec?.date) {
          recordMap[getUTCDateString(new Date(rec.date))] = rec;
        }
      });

      const regMap = {};
      regularizations.forEach((reg) => {
        if (reg?.entry_date) {
          regMap[getUTCDateString(new Date(reg.entry_date))] = reg;
        }
      });

      const days = getLast7DaysUTC();
      const summary = days.map((dateKey) => {
        const record = recordMap[dateKey] || null;
        const regularization = regMap[dateKey] || null;
        const [year, month, day] = dateKey.split('-').map(Number);
        const weekday = new Date(Date.UTC(year, month - 1, day)).toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' });

        let punchIn = '—', punchOut = '—', durationHours = null;
        const workHour = 8;
        let shortHour = 0, extraHour = 0;
        let isShort = false; // Button display condition

        if (record) {
          punchIn = fmt(record.punch_in);
          punchOut = fmt(record.punch_out);

          if (record.punch_in === 'weekly off' || record.punch_in?.toLowerCase().includes('off')) {
            isShort = false; // Off ke din apply nahi dikhega
          } else if (record.punch_in && record.punch_out) {
            const inTime = new Date(record.punch_in).getTime();
            const outTime = new Date(record.punch_out).getTime();
            if (outTime > inTime) {
              durationHours = (outTime - inTime) / (1000 * 60 * 60);
              durationHours = Math.round(durationHours * 10) / 10;
              if (durationHours > workHour) {
                extraHour = Math.round((durationHours - workHour) * 10) / 10;
              } else if (durationHours < workHour) {
                shortHour = Math.round((workHour - durationHours) * 10) / 10;
                isShort = true; // Kaam 8 hours se kam hua hai
              }
            } else {
              isShort = true;
              shortHour = workHour;
            }
          } else {
            // Missing Punch In ya Punch Out
            isShort = true;
            shortHour = workHour;
          }
        } else {
          // Absent / Koi Data Nahi
          isShort = true;
          shortHour = workHour; // Pura din short hai
        }

        let regStatus = '—';
        if (regularization) {
          if (typeof regularization.status === 'string' && regularization.status.trim() !== '') {
            regStatus = regularization.status;
          } else {
            regStatus = 'Pending';
          }
        }

        return {
          rawDate: dateKey,
          date: fmtDate(dateKey),
          week: weekday,
          punchIn,
          punchOut,
          duration: durationHours !== null ? formatDuration(durationHours) : '—',
          workHour: formatDuration(workHour),
          shortHour: shortHour > 0 ? formatDuration(shortHour) : '0 HOURS',
          extraHour: extraHour > 0 ? formatDuration(extraHour) : '0 HOURS',
          isShort: isShort,
          regularization: regStatus,
        };
      });

      setWeeklyData(summary);
    } catch (error) {
      console.error('❌ Fetch Weekly Summary Error:', error);
      setWeeklyData([]);
    } finally {
      setWeeklyLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchWeeklySummary();
    }
  }, [userId, company_id]);

  // --- Modal Handlers ---
  const handleOpenRegularizeModal = (rawDate) => {
    setCategory('');
    setTimeType('');
    setBeginningTime('12:00 AM');
    setEndTime('12:00 AM');
    setSelectedDate(rawDate);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCategory('');
    setTimeType('');
    setBeginningTime('12:00 AM');
    setEndTime('12:00 AM');
    setSelectedDate('');
  };

  const handleSave = async () => {
    if (!category || !timeType || !selectedDate) {
      toast.error('Please fill all the required fields (Category, Time Type, and Date).');
      return;
    }

    const formattedBeginning = convertTo24Hour(beginningTime);
    const formattedEnd = convertTo24Hour(endTime);

    const formData = {
      company_id: company_id,
      employee_id: userId,
      customer_id: userId,
      category: category,
      time_type: timeType,
      entry_date: selectedDate,
      beginning: formattedBeginning,
      end_time: formattedEnd,
      remarks: timeType,
    };

    try {
      setSaving(true);
      const res = await configService.attendanceregularization(formData);

      if (res?.status === true || res?.data?.status === true || res?.status === 201) {
        toast.success('Attendance Regularization saved successfully!');
        handleCloseModal();
        await fetchWeeklySummary();
      } else {
        toast.error(res?.data?.message || res?.message || 'Failed to save.');
      }
    } catch (error) {
      console.error('Error saving attendance regularization:', error);
      toast.error(`Error: ${error?.response?.data?.message || error?.message || 'Server Error'}`);
    } finally {
      setSaving(false);
    }
  };

  // --- Clock Picker Handlers ---
  const handleOpenPicker = (field, currentTime) => {
    setActiveField(field);
    try {
      const [time, period] = currentTime.split(' ');
      const [hr, min] = time.split(':');
      setSelectedHour(hr || '12');
      setSelectedMinute(min || '00');
      setAmpm(period || 'AM');
    } catch (e) {
      setSelectedHour('12');
      setSelectedMinute('00');
      setAmpm('AM');
    }
    setPickerView('hours');
    setOpenPicker(true);
  };

  const handleClockSave = () => {
    const formattedTime = `${selectedHour}:${selectedMinute} ${ampm}`;
    if (activeField === 'beginning') { setBeginningTime(formattedTime); }
    else { setEndTime(formattedTime); }
    setOpenPicker(false);
  };

  const currentData = pickerView === 'hours' ? hoursData : minutesData;
  const currentSelection = pickerView === 'hours' ? selectedHour : selectedMinute;
  const currentRotation = currentData.find(d => d.n === currentSelection)?.deg || 0;

  return (
    <div className="weekly-page-wrapper">
      <div className="weekly-modal-card weekly-page-card">
        <div className="weekly-modal-body">
          <h3 className="weekly-modal-title">Weekly Attendance Summary</h3>

          {weeklyLoading ? (
            <div className="weekly-loading-wrap">
              <div className="weekly-spinner" />
            </div>
          ) : weeklyData.length === 0 ? (
            <div className="weekly-empty-text">No attendance data available.</div>
          ) : (
            <div className="weekly-table-container">
              <div className="weekly-table-responsive">
                <table className="weekly-table">
                  <thead>
                    <tr>
                      <th>DATE</th>
                      <th>WEEK</th>
                      <th>PUNCH IN</th>
                      <th>PUNCH OUT</th>
                      <th>DURATION</th>
                      <th>WORK HOUR</th>
                      <th>SHORT HOUR</th>
                      <th>EXTRA HOUR</th>
                      <th>REGULARIZATION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {weeklyData.map((row, index) => {
                      const isRegSet = row.regularization !== '—';
                      // Agar row current date ki hai toh Disable the button
                      const isCurrentDate = row.rawDate === todayDateStr;

                      return (
                        <tr key={index}>
                          <td>{row.date}</td>
                          <td className="weekly-day-cell" style={{ fontWeight: 600 }}>{row.week}</td>
                          <td className={row.punchIn === 'weekly off' ? 'weekly-off' : ''}>{row.punchIn}</td>
                          <td className={row.punchOut === 'weekly off' ? 'weekly-off' : ''}>{row.punchOut}</td>
                          <td>{row.duration}</td>
                          <td>{row.workHour}</td>
                          <td className={row.shortHour !== '0 HOURS' ? 'weekly-short-hour' : ''}>{row.shortHour}</td>
                          <td>{row.extraHour}</td>
                          <td>
                            {isRegSet ? (
                              <span className={`weekly-reg-badge weekly-reg-${row.regularization.toLowerCase()}`}>
                                {row.regularization}
                              </span>
                            ) : row.isShort ? (
                              <Button
                                size="small"
                                variant="outlined"
                                disabled={isCurrentDate}
                                onClick={() => handleOpenRegularizeModal(row.rawDate)}
                                sx={{
                                  textTransform: 'none',
                                  fontSize: 12,
                                  fontWeight: 600,
                                  borderColor: isCurrentDate ? 'inherit' : '#6c5ce7',
                                  color: isCurrentDate ? 'inherit' : '#6c5ce7',
                                  borderRadius: 2,
                                  px: 2,
                                  py: 0.3,
                                  '&:hover': { borderColor: '#5b4bc4', bgcolor: 'rgba(108, 92, 231, 0.08)' }
                                }}
                              >
                                Apply
                              </Button>
                            ) : (
                              <span className="weekly-off">—</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ── Apply Regularization Modal ── */}
      <Modal open={openModal} onClose={handleCloseModal} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, zIndex: 1000 }}>
        <Card sx={{ width: '100%', maxWidth: 500, bgcolor: '#ffffff', borderRadius: 4, color: '#1e293b', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}>
          <CardContent sx={{ p: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 3, color: '#1e293b' }}>
              New Regularization Request
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel id="cat-label">Category</InputLabel>
                  <Select labelId="cat-label" value={category} label="Category" onChange={(e) => setCategory(e.target.value)}>
                    <MenuItem value="Working Times">Working Times</MenuItem>
                    <MenuItem value="Break">Break</MenuItem>
                    <MenuItem value="Overtime">Overtime</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel id="type-label">Time Type</InputLabel>
                  <Select labelId="type-label" value={timeType} label="Time Type" onChange={(e) => setTimeType(e.target.value)}>
                    <MenuItem value="Attendance Regularization">Attendance Regularization</MenuItem>
                    <MenuItem value="On Duty">On Duty</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <TextField label="Date" type="date" value={selectedDate} fullWidth size="small"
                  InputProps={{ readOnly: true, endAdornment: (<InputAdornment position="end"><CalendarTodayIcon sx={{ color: '#6c5ce7', fontSize: '1.2rem' }} /></InputAdornment>) }}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField label="Beginning" value={beginningTime} onClick={() => handleOpenPicker('beginning', beginningTime)} fullWidth size="small"
                  InputProps={{ readOnly: true, endAdornment: (<InputAdornment position="end"><AccessTimeIcon sx={{ color: '#6c5ce7', cursor: 'pointer' }} /></InputAdornment>) }}
                  sx={{ cursor: 'pointer', '& input': { cursor: 'pointer' } }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField label="End" value={endTime} onClick={() => handleOpenPicker('end', endTime)} fullWidth size="small"
                  InputProps={{ readOnly: true, endAdornment: (<InputAdornment position="end"><AccessTimeIcon sx={{ color: '#6c5ce7', cursor: 'pointer' }} /></InputAdornment>) }}
                  sx={{ cursor: 'pointer', '& input': { cursor: 'pointer' } }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField label="Created By" value={userId || 'User'} fullWidth size="small"
                  InputProps={{ readOnly: true, startAdornment: (<InputAdornment position="start"><AccountCircleIcon sx={{ color: '#94a3b8', mr: 0.5 }} /></InputAdornment>) }}
                  sx={{ '& .MuiOutlinedInput-root': { bgcolor: '#f8fafc' } }}
                />
              </Grid>
            </Grid>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 4 }}>
              <Button onClick={handleCloseModal} sx={{ color: '#64748b', textTransform: 'none' }}>Cancel</Button>
              <Button variant="contained" onClick={handleSave} disabled={saving} sx={{ bgcolor: '#6c5ce7', color: '#fff', px: 3, textTransform: 'none', '&:hover': { bgcolor: '#5b4bc4' } }}>
                {saving ? 'Saving...' : 'Save'}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Modal>

      {/* ── CUSTOM RADIAL CLOCK DIALOG PICKER ── */}
      <Dialog open={openPicker} onClose={() => setOpenPicker(false)} PaperProps={{ sx: { borderRadius: 4, p: 3, maxWidth: '340px', width: '100%', bgcolor: '#ffffff' } }} sx={{ zIndex: 1100 }}>
        <DialogContent sx={{ p: 0, overflow: 'visible' }}>
          <Typography variant="body2" sx={{ color: '#64748b', mb: 2, fontWeight: 500 }}>Select time</Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 3 }}>
            <Box onClick={() => setPickerView('hours')} sx={{ bgcolor: pickerView === 'hours' ? 'rgba(108, 92, 231, 0.1)' : '#f8fafc', px: 2.5, py: 1.5, borderRadius: 2, cursor: 'pointer', border: pickerView === 'hours' ? '1px solid #6c5ce7' : '1px solid #cbd5e1' }}>
              <Typography variant="h3" sx={{ color: pickerView === 'hours' ? '#6c5ce7' : '#1e293b', fontWeight: 500 }}>{selectedHour}</Typography>
            </Box>
            <Typography variant="h4" sx={{ color: '#64748b' }}>:</Typography>
            <Box onClick={() => setPickerView('minutes')} sx={{ bgcolor: pickerView === 'minutes' ? 'rgba(108, 92, 231, 0.1)' : '#f8fafc', px: 2.5, py: 1.5, borderRadius: 2, cursor: 'pointer', border: pickerView === 'minutes' ? '1px solid #6c5ce7' : '1px solid #cbd5e1' }}>
              <Typography variant="h3" sx={{ color: pickerView === 'minutes' ? '#6c5ce7' : '#1e293b', fontWeight: 500 }}>{selectedMinute}</Typography>
            </Box>
            <ToggleButtonGroup orientation="vertical" value={ampm} exclusive onChange={(e, val) => val && setAmpm(val)} sx={{ ml: 1, bgcolor: '#f8fafc', '& .MuiToggleButton-root': { px: 1.5, py: 0.8 } }}>
              <ToggleButton value="AM">AM</ToggleButton>
              <ToggleButton value="PM">PM</ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
            <Box sx={{ width: 220, height: 220, borderRadius: '50%', bgcolor: '#f8fafc', position: 'relative', border: '1px solid #cbd5e1' }}>
              <Box sx={{ width: 6, height: 6, bgcolor: '#6c5ce7', borderRadius: '50%', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 3 }} />
              <Box sx={{ position: 'absolute', width: 2, height: 76, bgcolor: '#6c5ce7', bottom: '50%', left: '50%', transformOrigin: 'bottom center', transform: `translateX(-50%) rotate(${currentRotation}deg)`, zIndex: 1 }} />
              {currentData.map((item) => {
                const radius = 80;
                const angleRad = (item.deg - 90) * (Math.PI / 180);
                const x = 110 + radius * Math.cos(angleRad);
                const y = 110 + radius * Math.sin(angleRad);
                const isSelected = currentSelection === item.n;

                return (
                  <Box key={item.n} onClick={() => { if (pickerView === 'hours') { setSelectedHour(item.n); setPickerView('minutes'); } else { setSelectedMinute(item.n); } }}
                    sx={{ position: 'absolute', left: x, top: y, transform: 'translate(-50%, -50%)', fontSize: '0.85rem', color: isSelected ? '#fff' : '#475569', cursor: 'pointer', zIndex: 2, width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', transition: '0.1s', ...(isSelected && { bgcolor: '#6c5ce7', fontWeight: 'bold' }), }}
                  >
                    {parseInt(item.n)}
                  </Box>
                );
              })}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between', px: 0, pb: 0, pt: 2 }}>
          <IconButton size="small" sx={{ color: '#64748b' }}><KeyboardIcon /></IconButton>
          <Box>
            <Button onClick={() => setOpenPicker(false)} sx={{ textTransform: 'none', fontWeight: 600, color: '#64748b', mr: 1 }}>Cancel</Button>
            <Button onClick={handleClockSave} sx={{ textTransform: 'none', fontWeight: 700, color: '#6c5ce7' }}>OK</Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}